import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { lastValueFrom, take } from 'rxjs';
import { AppResource } from 'src/app/app.resource';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { PartnershipVM } from 'src/app/core/models/partnership.model';
import { Question } from 'src/app/core/models/question.model';
import { cloneResumeStep } from 'src/app/core/models/resume-step.model';
import { Step } from 'src/app/core/models/step.model';
import { Stepper } from 'src/app/core/models/stepper.model';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { MatomoConstants } from 'src/app/shared/constants/matomo.constants';
import { NUMBER_PIECES_PATH, ROOT_PATH } from 'src/app/shared/constants/route.constants';
import {
  getMetropoleBareme,
  getMetropoleBaseName,
  getMetropoleCityName,
  getMetropolePartnershipLogo,
  getMetropoleResidentName
} from 'src/app/shared/helpers/metropole-helper.service';
import { PopUpInfoVM } from 'src/app/shared/models/components/popupinfoVm';
import { environment } from 'src/environments/environment';
import { String } from 'typescript-string-operations';
import * as fromRoot from '../../../core/state/core.state';
import * as fromHousing from '../../../core/state/housing';
import * as fromInfo from '../../../core/state/info';
import * as fromPath from '../../../core/state/path';
import { isPartner } from 'src/app/shared/utils/brandUtils';

@Component({
  selector: 'app-preferential-rate',
  templateUrl: './preferential-rate.component.html',
  styles: ''
})
export class PreferentialRateComponent extends BaseComponent implements OnInit {
  preferentialRateOvered = false;
  noPreferentialRatemouseOvered = false;
  preferentialRateChosen = false;
  noPreferentialRateChosen = false;

  rfrInferiorOvered = false;
  rfrSuperiorOvered = false;
  rfrNoAnswerOvered = false;

  rfrInferiorChosen = false;
  rfrSuperiorChosen = false;
  rfrNoAnswerChosen = false;

  // numberOfPeople = 0;
  formPeople: FormGroup<{ people: FormControl<number> }> = new FormGroup<{
    people: FormControl<number>;
  }>({
    people: new FormControl<number>(1, [
      Validators.required,
      Validators.min(1),
      Validators.max(10)
    ]) as FormControl
  });

  plafondResources = 0;
  revenue = false;
  displayModal = false;

  logoGrenoble: string = this.resource.preferentialrate.imgGrenoble;

  cityName: string = '';
  pathType = PathType;
  path!: PathType;
  previousPath!: PathType;

  get brand() {
    return environment.brand;
  }

  override step: Step = {
    step: this.resource.header.stepHousing,
    stepNumber: 1,
    subStep: this.resource.header.subStepPreferentialRate,
    subStepNumber: 5
  };

  popupInfo!: PopUpInfoVM;
  showDialog = false;
  className: string = 'img-cap';

  popupInfoNumberInHome!: PopUpInfoVM;
  popupInfoRevenu!: PopUpInfoVM;
  override question: Question = {
    libelle: this.resource.question.preferentialRate,
    popupInfo: undefined
  };

  public override currentPage = MatomoConstants.TARIFS;

  constructor(
    store: Store<fromRoot.State>,
    resources: AppResource,
    private readonly router: Router
  ) {
    super(store, resources);
  }

  override async ngOnInit() {
    await this.OverrideQuestionComponent();
    super.ngOnInit();
    this.updateResumeStepVisibility(true);
    this.loadStateData();
  }

  private async OverrideQuestionComponent() {
    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));
    this.previousPath = await lastValueFrom(
      this.store.select(fromPath.selectPreviousPathType).pipe(take(1))
    );
    if (isPartner(this.brand))
      this.question.libelle = String.format(
        this.resource.question.preferentialRate,
        getMetropoleResidentName(this.path)
      );
    else
      this.question.libelle = String.format(
        this.resource.question.preferentialRate,
        getMetropoleResidentName(this.path),
        getMetropoleBaseName(this.path),
        getMetropoleCityName(this.path)
      );

    // SET PLAFOND REVENUE
    this.className =
      this.path === this.pathType.HOUSING_CRETEIL ||
      this.path === this.pathType.HOUSING_GRENOBLE ||
      this.path === this.pathType.HOUSING_MARSEILLE
        ? 'img-cap'
        : 'img-cap-2';

    this.popupInfo = new PopUpInfoVM([
      String.format(this.resource.infobulle.preferentialRate1, getMetropoleBaseName(this.path))
    ]);
    // SET PARTNESHIP - 3 CASES
    if (this.path !== PathType.HOUSING_ETUDIANTE && this.path !== PathType.HOUSING) {
      let wording = this.resource.infobulle.partnership3;
      if (this.path === PathType.HOUSING_GRENOBLE) {
        wording = this.resource.infobulle.partnership1;
      } else if (this.path === PathType.HOUSING_LILLE) {
        wording = this.resource.infobulle.partnership2;
      }

      this.question.partnership = new PartnershipVM(
        String.format(wording, getMetropoleCityName(this.path)),
        getMetropolePartnershipLogo(this.path)
      );
    } else {
      this.question.partnership = undefined;
    }
  }

  private async loadStateData() {
    let housingData = await lastValueFrom(
      this.store.select(fromHousing.selectHousing).pipe(take(1))
    );

    if (this.path === PathType.HOUSING_GRENOBLE) {
      this.cityName = String.format(
        this.resource.preferentialrate.noP4,
        getMetropoleCityName(this.path)
      );
    } else if (this.path === PathType.HOUSING_LILLE) {
      this.cityName = String.format(
        this.resource.preferentialrate.noP3,
        getMetropoleCityName(this.path)
      );
    } else {
      this.cityName = String.format(
        this.resource.preferentialrate.noP2,
        getMetropoleCityName(this.path)
      );
    }

    if (housingData.SaisieHabitation.TarifPreferentiel) {
      this.preferentialRateChosen = true;
      const payload = {
        libelle: this.resource.question.preferentialRateN,
        prefixInfo: this.resource.question.preferentialRateN,
        partnership: undefined
      } as Partial<Question>;
      this.popupInfoNumberInHome = new PopUpInfoVM([this.resource.infobulle.preferentialRate2]);
      this.store.dispatch(fromInfo.updateQuestion({ payload }));
    }

    if (housingData.SaisieHabitation.CompositionFoyer != undefined) {
      this.formPeople.controls.people.setValue(housingData.SaisieHabitation.CompositionFoyer);
    }
    this.recalculatePlafondRessources();

    if (housingData.SaisieHabitation.RFRInferieurPlafond) {
      this.rfrSuperiorChosen = housingData.SaisieHabitation.RFRInferieurPlafond;
    }

    if (housingData.SaisieHabitation.ConfirmationRFRInferieurPlafond) {
      this.rfrInferiorChosen = housingData.SaisieHabitation.ConfirmationRFRInferieurPlafond;
    }
  }

  async onPreferentialRateChosen() {
    this.preferentialRateChosen = !this.preferentialRateChosen;
    if (this.noPreferentialRateChosen) {
      this.noPreferentialRateChosen = false;
    }

    const payload = {
      libelle: this.resource.question.preferentialRateN,
      partnership: undefined
    } as Partial<Question>;
    this.store.dispatch(fromInfo.updateQuestion({ payload }));

    this.popupInfoNumberInHome = new PopUpInfoVM([this.resource.infobulle.preferentialRate2]);
    this.store.dispatch(
      fromHousing.patchPreferentialType({
        payload: { TarifPreferentiel: this.preferentialRateChosen }
      })
    );

    await this.updateStepper();
  }

  async onRfrSuperiorChosen() {
    this.rfrSuperiorChosen = !this.rfrSuperiorChosen;
    this.rfrInferiorChosen = false;
    this.rfrNoAnswerChosen = false;

    if (this.rfrSuperiorChosen === true) {
      this.store.dispatch(
        fromHousing.patchPreferentialType({
          payload: {
            RFRInferieurPlafond: this.rfrSuperiorChosen,
            ConfirmationRFRInferieurPlafond: this.rfrInferiorChosen,
            MontantRFR: this.plafondResources
          }
        })
      );
      this.switchToHousingPath();
    }

    await this.updateStepper();
    await this.updateResumeStep(this.resource.resumestep.superior, false);

    this.router.navigate([`${ROOT_PATH}${NUMBER_PIECES_PATH}`]);
  }

  async onRfrInferiorChosen() {
    this.rfrInferiorChosen = !this.rfrInferiorChosen;
    this.rfrSuperiorChosen = false;
    this.rfrNoAnswerChosen = false;
    const payload = {
      libelle: this.resource.question.preferentialRateF
    } as Partial<Question>;
    this.store.dispatch(fromInfo.updateQuestion({ payload }));

    if (this.rfrInferiorChosen === true) {
      this.store.dispatch(
        fromHousing.patchPreferentialType({
          payload: {
            RFRInferieurPlafond: !this.rfrInferiorChosen,
            ConfirmationRFRInferieurPlafond: this.rfrSuperiorChosen
          }
        })
      );
    }

    await this.updateStepper();
    this.displayModal = true;
  }

  async onRfrNoAnswerChosen() {
    this.rfrNoAnswerChosen = !this.rfrNoAnswerChosen;
    this.rfrSuperiorChosen = false;
    this.rfrInferiorChosen = false;

    const payload = {
      libelle: this.resource.question.preferentialRateF,
      partnership: undefined
    } as Partial<Question>;
    this.store.dispatch(fromInfo.updateQuestion({ payload }));

    if (this.rfrNoAnswerChosen === true) {
      this.store.dispatch(
        fromHousing.patchPreferentialType({
          payload: { RFRInferieurPlafond: undefined }
        })
      );
      this.switchToHousingPath();
    }

    await this.updateStepper();
    await this.updateResumeStep(this.resource.resumestep.superior, true);
    this.router.navigate([`${ROOT_PATH}${NUMBER_PIECES_PATH}`]);
  }

  async onNoPreferentialRateChosen() {
    this.noPreferentialRateChosen = !this.noPreferentialRateChosen;
    if (this.preferentialRateChosen) {
      this.preferentialRateChosen = false;
    }

    this.store.dispatch(
      fromHousing.patchPreferentialType({
        payload: { TarifPreferentiel: this.preferentialRateChosen }
      })
    );

    // remove the partnership in the question
    const payload = {
      partnership: undefined
    } as Partial<Question>;
    this.store.dispatch(fromInfo.updateQuestion({ payload }));

    this.switchToHousingPath();

    await this.updateStepper();
    await this.updateResumeStep(this.resource.resumestep.superior, true);
    this.router.navigate([`${ROOT_PATH}${NUMBER_PIECES_PATH}`]);
  }

  onInputNumberChanges($event: Event) {
    this.recalculatePlafondRessources();
  }

  private dispatchNumberOfPeople() {
    this.store.dispatch(
      fromHousing.patchPreferentialType({
        payload: { CompositionFoyer: this.formPeople.controls.people.value }
      })
    );
  }

  recalculatePlafondRessources() {
    let referenceScale = getMetropoleBareme(
      this.path != PathType.HOUSING ? this.path : this.previousPath
    );
    if (referenceScale) {
      if (this.formPeople.controls.people.value > 0) {
        if (this.formPeople.controls.people.value <= 6) {
          this.plafondResources = referenceScale[this.formPeople.controls.people.value].Montant;
        } else {
          const extra = referenceScale[0].Montant;
          const six = referenceScale[6].Montant;
          this.plafondResources = six + extra * (this.formPeople.controls.people.value - 6);
        }
      } else {
        this.plafondResources = 0;
      }
    }
  }

  switchToRevenue() {
    this.dispatchNumberOfPeople();

    const payload = {
      libelle: this.resource.question.preferentialRateF
    } as Partial<Question>;

    this.popupInfoRevenu = new PopUpInfoVM(
      [this.resource.infobulle.preferentialRateRevenue1],
      this.resource.infobulle.preferentialRateRevenueImage
    );
    this.store.dispatch(fromInfo.updateQuestion({ payload }));
    this.revenue = true;
  }

  async validatePreferentialRate() {
    this.store.dispatch(
      fromHousing.patchPreferentialType({
        payload: { ConfirmationRFRInferieurPlafond: true, MontantRFR: this.plafondResources }
      })
    );

    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    this.displayModal = false;

    await this.updateStepper();
    await this.updateResumeStep(this.resource.resumestep.inferior, false);
    this.router.navigate([`${ROOT_PATH}${NUMBER_PIECES_PATH}`]);
  }

  switchToHousingPath() {
    this.store.dispatch(
      fromPath.updateType({
        pathType: PathType.HOUSING
      })
    );
    this.store.dispatch(
      fromPath.updatePreviousType({
        previousPathType: this.path != PathType.HOUSING ? this.path : this.previousPath
      })
    );
  }

  cancelPreferentialRate() {
    this.store.dispatch(
      fromHousing.patchPreferentialType({
        payload: { ConfirmationRFRInferieurPlafond: false }
      })
    );

    this.store.dispatch(
      fromHousing.patchPreferentialType({
        payload: { RFRInferieurPlafond: undefined }
      })
    );
    this.displayModal = false;
  }

  async onNoPreferentialRate() {
    this.store.dispatch(
      fromHousing.patchPreferentialType({
        payload: { TarifPreferentiel: false }
      })
    );
    this.switchToHousingPath();

    await this.updateStepper();
    await this.updateResumeStep(this.resource.resumestep.superior, true);
    this.router.navigate([`${ROOT_PATH}${NUMBER_PIECES_PATH}`]);
  }

  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    let tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.devis.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.lodging
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.preferentialrate
    );

    if (subtitleS) {
      subtitleS.isValid = true;
    }

    let subtitleN;
    subtitleN = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.numberpieces
    );

    if (subtitleN) {
      subtitleN.isVisible = true;
      subtitleN.isActive = true;
    }

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  async updateResumeStep(libelle: string, skip: boolean) {
    const resumeStep = await lastValueFrom(
      this.store.select(fromInfo.selectCurrentResumeStep).pipe(take(1))
    );

    const tmpResumeStep = cloneResumeStep(resumeStep);

    const stepResumeStep = tmpResumeStep.steps?.find(
      x => x.id == this.resource.resumestep.preferentialrate
    );

    if (stepResumeStep) {
      if (!skip) {
        stepResumeStep.step = libelle;
        stepResumeStep.isVisible = true;
      } else {
        stepResumeStep.step = '';
        stepResumeStep.isVisible = false;
      }
    } else {
      if (!skip)
        tmpResumeStep.steps?.push({
          id: this.resource.resumestep.preferentialrate,
          step: libelle,
          url: this.resource.resumestep.preferentialrate,
          isVisible: true
        });
    }
    this.store.dispatch(fromInfo.updateResumeStep({ payload: tmpResumeStep }));
  }

  setClassActive(value: boolean): string {
    return value ? 'active' : 'inactive';
  }
}
